import instance from "../Config/Config";

export const about_url = "pages/slug/about_us"
export const setting_url = "settings"





export const about_us = async()=>{
    const response = await instance.get(`${about_url}`)
    return response.data
}


export const get_page = async (slug) => {
    const response = await instance.get(`pages/slug/${slug}`)
    return response.data
}

export const setting_api = async()=>{
    const response = await instance.get(`${setting_url}`)
    return response.data
}


